var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-vue",staticStyle:{"padding":"20px"}},[(!_vm.erro)?_c('span',[_vm._v("autenticando ...")]):_vm._e(),(_vm.erro)?_c('span',[_vm._v("problemas ao se autenticar")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }